import './App.scss';

import React, { useEffect, useState } from 'react';
import MediaQuery from 'react-responsive';
import queryString from 'query-string';
import moment from 'moment';
import clone from 'clone';

import Request from 'utils/request';

import { breakpoints } from 'utils/constants';

import ActivityIndicator from "../../components/ActivityIndicator";
import SearchBoxes from './components/SearchBoxes';
import SearchResults from "./components/SearchResults";
import Sidebar from './components/Sidebar';

const App = () => {
    const [searchPerformed, setSearchPerformed] = useState(false);
    const [epiloggs, setEpiloggs] = useState([]);
    const [filter, setFilter] = useState('all');
    const [isAtEnd, setIsAtEnd] = useState(false);
    const [isInfiniteScrolling, setIsInfiniteScrolling] = useState(false);
    const [canInfiniteScroll, setCanInfiniteScroll] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [location, setLocation] = useState(null);
    const [metadata, setMetadata] = useState({pageNum: 0});
    const [nameSearchTerm, setNameSearchTerm] = useState('');
    const [qsFilters, setQsFilters] = useState(null);

    const qs = queryString.parse(window.location.search);
    let hasQueryString = qs != null && Object.keys(qs).length > 0;

    useEffect(() => {
        if(!hasQueryString) {
            searchEpiloggs();
        }
    }, []);

    useEffect(() => {
        if(qs.searchterm) {
            setNameSearchTerm(qs.searchterm);
            searchEpiloggs(qs.searchterm);

        }
    }, [qs.searchTerm, setNameSearchTerm]);

    useEffect(() => {
        if(qs.filters) {
            const f = JSON.parse(qs.filters);
            setQsFilters(f);
            if(f.zipCode) {
                setLocation({displayName: f.zipCode})
            }
        }
    }, [qs.filters, setQsFilters]);

    useEffect(() => {
        if(qs.pagenumber != null) {
            nextPageOfEpiloggs(qs.pagenumber);
        } else if(qsFilters) {
            console.log(qsFilters);
            searchEpiloggs();
        }
    }, [qs.pagenumber, qsFilters])

    useEffect(() => {
        if(searchPerformed) {
            searchEpiloggs();
        }
    }, [filter, location]);

    const searchEpiloggs = async (searchterm) => {
        if(isSearching) {
            return;
        }
        setCanInfiniteScroll(false);
        setIsSearching(true);
        const request = new Request();

        let path = `${process.env.REACT_APP_API_URL}/api/v1/search?page_num=0&page_size=20${generateFilterString()}${generateLocationString()}${generateNameString(searchterm)}${generateQsFilterString()}`;

        try {
            let res = await request.get(path, {baseURL: ''});

            let results = res.data.data.epiloggs;
            let meta = res.data.data.meta;
            setMetadata(meta);

            setIsAtEnd(res.data?.data?.epiloggs?.length === 0);
            setEpiloggs(results);
            setSearchPerformed(true);
            setIsSearching(false);
            setTimeout(() => setCanInfiniteScroll(true), 1000);
        } catch(err) {
            console.log(err);
        }

    };

    const nextPageOfEpiloggs = async (pageNum) => {
        if(isInfiniteScrolling || isAtEnd) {
            return;
        }

        setIsInfiniteScrolling(true);
        const request = new Request();

        const newMetadata = clone(metadata);
        newMetadata.pageNum = pageNum || newMetadata.pageNum + 1;
        setMetadata(newMetadata);

        let path = `${process.env.REACT_APP_API_URL}/api/v1/search?page_num=${newMetadata.pageNum}&page_size=20${hasQueryString && qs.filters && Object.keys(qs.filters).length > 0 ? `&filters=${encodeURIComponent(JSON.stringify(qs.filters))}` : ''}${generateFilterString()}${generateLocationString()}${generateNameString()}${generateQsFilterString()}`;

        try {
            let res = await request.get(path, {baseURL: ''});

            let results = epiloggs.concat(res.data.data.epiloggs);
            let meta = res.data.data.meta;

            setIsAtEnd(res.data?.data?.epiloggs?.length === 0);
            setMetadata(meta);
            setEpiloggs(results);
            setIsInfiniteScrolling(false);
        } catch(err) {
            console.log(err);
        }

    };

    const generateFilterString = () => {
        if(filter === 'all') {
            return '';
        } else {
            return `&date_after=${moment().subtract(1, filter).format('YYYY-MM-DD')}`;
        }
    };

    const generateLocationString = () => {
        if(location && location.lat && location.lng) {
            return `&latitude=${location.lat}&longitude=${location.lng}`;
        } else {
            return '';
        }
    };

    const generateNameString = (searchterm) => {
        if(!nameSearchTerm && !searchterm) {
            return '';
        } else {
            return `&name=${encodeURIComponent(searchterm || nameSearchTerm)}`;
        }
    };

    const generatePageLinkPath = (pageChange) => {
        let path = window.location.pathname + '?';

        if(qsFilters && Object.keys(qsFilters).length > 0) {
            path = path + `filters=${encodeURIComponent(JSON.stringify(qsFilters))}&`;
        }
        //`${window.location.pathname}${metadata.pageNum !== 1 ? `?pagenumber=${metadata.pageNum - 1}` : ''}`
        if(pageChange === 1 || metadata.pageNum !== 1) {
            path += `pagenumber=${parseInt(metadata.pageNum) + parseInt(pageChange)}`;
        }

        return path;
    };

    const generateQsFilterString = () => {
        if(!qsFilters || Object.keys(qsFilters).length === 0) {
            return '';
        } else {
            let filterArray = Object.keys(qsFilters).map((key) => {
                switch(key) {
                    case 'accountId':
                        return `&account_id=${qsFilters.accountId}`;
                    case 'providerId':
                        return `&provider_id=${qsFilters.providerId}`;
                    case 'radius':
                        return `&distance_meters=${qsFilters.radius}`;
                    case 'zipCode':
                        return `&zip=${qsFilters.zipCode}`;
                    case 'multipleZipCodes':
                        let zips = qsFilters.multipleZipCodes.split(',');
                        let zipString = '';
                        zips.forEach((z) => {
                            zipString += `&zips=${z}`;
                        });
                        return zipString;
                    case 'multipleProviderIds':
                        let providerIds = qsFilters.multipleProviderIds.split(',');
                        let providerIdsString = '';
                        providerIds.forEach((z) => {
                            providerIdsString += `&provider_ids=${z}`;
                        });
                        return providerIdsString;
                    default:
                        return null;
                }
            });
            return filterArray.join('');
        }
    };

    return (
        <div className="wrapper epilogg-search">
            <div className="epilogg-search__left-col">
                <SearchBoxes
                    isSearching={isSearching}
                    location={location}
                    nameSearchTerm={nameSearchTerm}
                    searchEpiloggs={searchEpiloggs}
                    setLocation={(location) => {
                        setQsFilters(null);
                        setLocation(location);
                    }}
                    setNameSearchTerm={setNameSearchTerm}
                />

                <MediaQuery maxWidth={breakpoints.maxTablet}>
                    {(matches) => {
                        if (matches) {
                            return (
                                <Sidebar
                                    setFilter={setFilter}
                                    selectedFilter={filter}
                                />
                            );
                        } else {
                            return null;
                        }
                    }}
                </MediaQuery>

                {isSearching ? (
                    <div className="epilogg-search__activity-indicator">
                        <ActivityIndicator />
                    </div>
                ) : (
                    <>
                        {searchPerformed && (!epiloggs || epiloggs.length === 0) ? (
                            <div className="epilogg-search__no-results">
                                No epiloggs found. Please search again.
                            </div>
                        ) : (
                            <>
                            {/*<InfiniteScroll
                                pageStart={0}
                                loadMore={infiniteScrollEpiloggs}
                                hasMore={!isAtEnd}
                                loader={null}
                            >*/}
                                <SearchResults
                                    epiloggs={epiloggs}
                                />

                                <div className="epilogg-search__load-more">
                                    {metadata.pageNum !== 0 ? (
                                        <a
                                            href={generatePageLinkPath(-1)}
                                        >
                                            &laquo; Previous Page
                                        </a>
                                    ) : <div />}

                                    <a
                                        href={generatePageLinkPath(1)}
                                    >
                                        Next Page &raquo;
                                    </a>
                                </div>

                                {isInfiniteScrolling && (
                                    <div className="epilogg-search__infinite-scroll-activity-indicator"><ActivityIndicator /></div>
                                )}

                                {isAtEnd && (
                                    <div className="epilogg-search__at-end">NO MORE RESULTS</div>
                                )}
                            {/*</InfiniteScroll>*/}
                            </>
                        )}
                    </>
                )}
            </div>


            <MediaQuery minWidth={breakpoints.tablet}>
                {(matches) => {
                    if (matches) {
                        return (
                            <Sidebar
                                setFilter={setFilter}
                                selectedFilter={filter}
                            />
                        );
                    } else {
                        return null;
                    }
                }}
            </MediaQuery>
        </div>
    );
};

export default App;
